module.exports = __webpack_public_path__ + "static/media/checkmark.70ca2c77.svg";